import { Link } from "react-router-dom";
import { Phone, Mail, MapPin, MessageCircle } from "lucide-react";
import { Logo } from "./Logo";
import { useLang } from "../../i18n/LangContext";
import { useSite } from "../../lib/SiteContext";
import { scrollToId } from "./SmoothScroll";

export const Footer = () => {
  const { t, lang } = useLang();
  const { settings: s } = useSite();
  const contacts = [
    [Phone, s.phone, s.phone ? `tel:${s.phone.replace(/[^\d+]/g, "")}` : null],
    [Mail, s.email, s.email ? `mailto:${s.email}` : null],
    [MessageCircle, s.whatsapp ? "WhatsApp" : "", s.whatsapp ? `https://wa.me/${s.whatsapp.replace(/\D/g, "")}` : null],
    [MapPin, s.address, null],
  ].filter(([, v]) => v);

  return (
    <footer className="border-t border-white/10 pt-20" data-testid="site-footer">
      <div className="mx-auto max-w-7xl px-5 lg:px-8">
        <p className="font-display text-[13vw] font-extrabold leading-[0.85] tracking-tighter text-outline lg:text-[10rem]">{t.footer.tag}</p>
        <div className="mt-16 grid gap-10 border-t border-white/10 py-12 md:grid-cols-3">
          <div>
            <Logo />
            <p className="mt-4 max-w-xs text-sm text-slate-400">{t.hero.over}</p>
            {s.ceo_name && (
              <p className="mt-4 text-sm text-slate-300" data-testid="footer-ceo">
                {(lang === "hi" ? s.ceo_title_hi : s.ceo_title_en) || ""}: <span className="font-semibold text-white">{s.ceo_name}</span>
              </p>
            )}
          </div>
          <div>
            <p className="text-xs uppercase tracking-[0.2em] text-slate-400">{t.footer.links}</p>
            <ul className="mt-4 grid grid-cols-2 gap-3 text-sm">
              {["services", "calculator", "solutions", "impact", "why", "about", "find", "join", "track"].map((l) => (
                <li key={l}><button onClick={() => scrollToId(l)} className="text-slate-300 hover:text-saffron" data-testid={`footer-${l}-link`}>{t.nav[l]}</button></li>
              ))}
            </ul>
          </div>
          <div>
            <p className="text-xs uppercase tracking-[0.2em] text-slate-400">{t.footer.contact}</p>
            <ul className="mt-4 space-y-3 text-sm">
              {contacts.map(([I, v, href]) => (
                <li key={v} className="flex items-start gap-3 text-slate-300">
                  <I size={16} className="mt-0.5 shrink-0 text-saffron" />
                  {href ? <a href={href} className="hover:text-white" data-testid="footer-contact-link">{v}</a> : <span>{v}</span>}
                </li>
              ))}
            </ul>
          </div>
        </div>
        <div className="flex flex-col justify-between gap-3 border-t border-white/10 py-6 text-xs text-slate-400 sm:flex-row">
          <p>© {new Date().getFullYear()} Indian Pay Hub. {t.footer.rights}</p>
          <Link to="/admin" className="hover:text-white" data-testid="footer-admin-link">{t.footer.admin}</Link>
        </div>
      </div>
    </footer>
  );
};
